enum SalesModuleApiSuffixModels {
  PRIORITY = 'priorities',
  LEADS = 'leads',
  QUOTATION_VERSION_VOID = 'quotation-version/void',
  QUOTATION_EMAIL = 'quotation/email',
  QUOTATION_VERSION_CONFIRMATION = 'quotation-version/confirmation',
  RAW_LEADS = 'raw-leads',
  RAW_LEADS_TASKS = 'task-rawleads',
  LEADS_TASKS = 'tasks-leads',
  CALLS_TASKS = 'tasks-calls',
  RAW_LEADS_IMPORT = 'raw-leads/import',
  RAW_LEADS_PROCESS_FILES = 'raw-leads/imports',
  SITE_TYPES = 'site-types',
  UX_SITE_TYPES = 'ux/site-types',
  SALEA_API_GROUPS = 'ux/lead-groups',
  UX_LEAD_SOURCES = 'ux/lead-sources',
  UX_STREET_TYPES = 'ux/streettypes',
  AGREEMENT_TABS = 'agreement-tabs',
  CALL_CATEGORIES = 'call-categories',
  UX_TITLES = 'ux/titles',
  SERVICE_TYPES = 'service-types',
  UX_LEAD_GROUPS = 'ux/lead-groups',
  LEAD = 'leads',
  LSS_SCHEMES_SEARCH = 'ux/lss-schemes/search',
  LEAD_INFO = 'lead-info',
  UX_SERVICE_TYPES = 'ux/service-types',
  UX_SERVICE_GROUPS = 'ux/service-groups',
  SERVICE_TYPES_DETAILS = "service-type-detail",
  AGREEMENTS_FINAL_CONFIRMATION = 'agreements-final/confirm/status',
  AGREEMENT_DOCUMENTS = 'agreement-documents',
  NEW_LEAD_ITEM_GET = 'get-for-new-lead-item',
  LEAD_SERVICE = "lead-service",
  AGREEMENTS_SERVICE = 'agreements/service',
  CUSTOMER_DUPLICATE_VALIDATION = 'customers/duplicate/validate',
  AGREEMENTS_INSTALLATION = 'agreements-installation',
  LEAD_ITEM = "lead-items",
  DELETE_SYSTEM_TYPE = 'lead-items/system-type',
  UX_Quotation_TYPES = "ux/quotation-types",
  PARTITIONS_CUSTOMER = 'ux/partitions-customer',
  GET_CUSTOMER_BY_ID = 'customers',
  QUOTATION = "quotation",
  UX_UPFRONT_PAYMENT_CONFIG = 'ux/upfront-payment-config',
  PARTITIONS_GENERATE = 'partitions/generate',
  LEAD_SERVICE_LOAD = "lead-service-load",
  PARTITIONS = 'partitions',
  PARTITIONS_SEARCH = 'partitions-search',
  PARTITION_INSERT = 'partitions-insert',
  CALL_CATEGORIES_UNMAPPED = "ux/call-categories/un-mapped",
  REPOSITORY = "Repository",
  REPOSITORY_TYPE = "ux/repository-type",
  CREATE_REPOSITORY = 'repository',
  SALES_DISCOUNT = 'sales-discount',
  UX_PRICELIST_TYPES = "ux/price-list-types",
  UX_PRICELIST_NAMES = "ux/price-list-names",
  UX_ITEM_OWNER_SHIP_TYPE = 'ux/item-owner-ship-type',
  EQUIPMENT_PRICE = "equipment/price",
  EQUIPMENT_PRICE_Duplicate = "equipment/price/duplicate",
  LEAD_STEP_PROCESS = 'lead-step-process',
  SPECIAL_INSTRUCTIONS_LEAD_DETAILS = 'special-instructions/lead/details',
  SPECIAL_INSTRUCTIONS = 'special-instructions',
  SITE_HAZARD_LEAD_DETAILS = 'site-hazard/lead/details',
  SITE_HAZARD = 'site-hazard',
  ACCESS_PREMISES_LEAD_DETAILS = 'access-premises',
  ACCESS_PREMISES = 'access-premises',
  SERVICE_PRICE_CATEGORY = "service-price-category",
  SERVICE_PRICE_SERVICE = "service-price-details",
  SERVICE_PRICE = "service-price",
  SERVICE_PRICE_ENABLEDISABLE = "service-price/enabledisable",
  UX_SERVICE_CATEGORY = "ux/service-category",
  UX_ITEM_CATEGORY = "ux/item-category/search",
  UX_ITEMOWNERSHIPTYPE = "ux/item-owner-ship-type",
  UX_DISTRICTS = 'ux/service-price-districts',
  SERVICE_PRICE_INSERT = "service-price/bulkInsert-Update",
  SERVICE_MAPPING = "service-mappings",
  SERVICE_PRICE_UPDATE = "service-price/bulkUpdate",
  SERVICE_PRICE_NAME = "service-price-service",
  DOA_DISCOUNT = 'doa-discount',
  KEY_HOLDERS_BY_LEAD = 'key-holders-by-lead',
  KEY_HOLDERS_BY_AGREEMENT = 'key-holders/agreement',
  KEY_HOLDERS_LEAD = 'key-holders/lead/details',
  KEY_HOLDERS = "key-holders",
  FOLLOWUP_TYPE = 'ux/followup-type',
  FOLLOWUP = 'followups',
  DOMESTIC_WORKERS_BULK = 'domestic-workers/bulk',
  DOMESTIC_WORKERS = 'domestic/workers',
  DOMESTIC_WORKERS_BY_LEAD_ID = "domestic/workers/lead/details",
  STEP_PROCESS_HISTORY = 'step-process/history',
  UX_DOMESTIC_WORKER_TYPES = 'ux/domestic-worker-types',
  BILLING_INTERVALS = 'billing-intervals',
  BILLING_INTERVALS_BULK_INSERT = 'billing-intervals/bulkinsert',
  MERCANTILE_USER_CODE = 'division-user-code',
  TEST_RUN_CONFIGURATION = "billingtest-runconfig",
  UX_TEST_RUN_PEROID = "ux/testrun-periods",
  BILL_RUN_DATE_CONFIGURATION = "run-date-config",
  UX_BILLING_FINANCIAL_YEARS = "ux/financial-years",
  UX_BILLING_FINANCIAL_YEAR_DETAILS = "ux/financial-year-details",
  BANKACCOUNTTYPE = 'bank-account-types',
  UX_ACCOUNTTYPE = 'ux/account-types',
  BANKING_ACCOUNT_TYPES = 'ux/customer-debtors/account',
  UX_CONTRACT_TYPES = 'ux/customer-debtors/contract',
  BANKACCOUNTTYPE_BULK_INSERT = 'bank-account-types/bulkinsert',
  PAYMENTMETHOD = 'payment-methods',
  UX_PAYMENT_METHODS = 'ux/payment-methods',
  UX_DEBTOR_PAYMENT_METHODS = 'ux/debtor-payment-type',
  MERCANTILE_USER_CODE_DETAILS = 'division-user-code-detail',
  DEBITORDER_BULK = 'debit-order-run-codes/bulk-insert',
  DEBITORDERRUNCODES = 'debit-order-run-codes',
  CANCEL_REASON = 'cancel-reason',
  CANCEL_REASON_DETAILS = 'cancel-reason/SubReason_Details',
  CANCEL_SUBREASON = 'cancel-sub-reason',
  UX_BANKS = 'ux/banks',
  UX_ACCOUNT_TYPES = 'ux/account-types',
  UX_ACCOUNT_HOLDER_DEBITOR = 'ux/account/holder/debitor',
  UX_BANK_BRANCH = 'ux/bank-branch',
  UX_BANK_BRANCHES = 'ux/bank-branches',
  UX_AGREEMENTS = 'ux/agreements',
  UX_AGREEMENT_TYPES = 'ux/agreement-types',
  ACCOUNT_HOLDERS_BY_LEAD = 'account/holder/lead/details',
  INSTALLATION_CHECKLIST = 'installation/checklist',
  CHECKLIST = 'check-list',
  UX_ACCOUNT_HOLDER_TYPES = 'ux/account-holder/type',
  ACCOUNT_HOLDER = 'account/holder',
  ACCOUNT_HOLDER_PRIMARY_ADDRESS = 'account/holder/primary-address',
  COMPANY_BANK_ACCOUNTS_CONFIGURATION = "company-bank-accounts",
  UX_BANK = "ux/banks",
  CUSTOMER_CREDIT_VETTING_REPORT = 'customer/credit-vetting/report',
  CUSTOMER_CREDIT_VETTING = 'customer/credit-vetting',
  UX_ACCOUNT_TYPE = "ux/account-types",
  UX_ACCOUNT_PURPOSE = "ux/account-purpose",
  BANK_BRANCH = 'bank-branch',
  UX_PANEL_TYPES = 'ux/panel-types',
  UX_TYPES_OF_SYSTEM = 'ux/item-owner-ship-type',
  INSTALLATION_INFO_DETAILS = 'installation-info/details',
  INSTALLATION_INFO = 'installation-info',
  INSTALLATION_INFO_BY_AGREEMENT = 'installation-info/agreement',
  INSTALLATION_INFO_BY_LEAD = "installation-info-by-lead",
  UX_BANK_BRANCH_BY_BANK = 'ux/bank-branch-by-bank',
  TICKET_GROUP = "ticket-groups",
  ACTION_TYPE = 'ticket-types',
  UX_ACTION_GROUP = "ux/ticket-groups",
  ACTION_TYPE_DETAILS = "ticket-type-details",
  UX_SUBSCRIPTIONS = 'ux/subscriptions',
  TICKET_OUTCOME_CONFIGURATION = 'tickets-outcome-configuration',
  UX_TICKET_OUTCOME_CONFIGURATION = 'ux/tickets-outcome-configuration',
  TICKET_ALTERNATE_CONTACTS = 'tickets-alternate-contacts',
  TICKET_ALTERNATE_CONTACTS_DETAIL = 'tickets-alternate-contacts/detail',
  TICKET_CANCELLATION_REASON = 'tickets-cancellation-reason',
  UX_TICKET_CANCELLATION_REASON = 'ux/tickets-cancellation-reason',
  TICKET_CANCELLATION_SUB_REASON = 'tickets-cancellation-sub-reason',
  TICKET_CANCELLATION_SUB_REASON_DETAIL = 'tickets-cancellation-sub-reason/detail',
  UX_TICKET_CANCELLATION_SUB_REASON = 'ux/tickets-cancellation-sub-reason',
  SUBSCRIPTIONS = 'subscriptions',
  UX_TICKETTYPES = 'ux/ticket-types',
  UX_TICKETSTATUS = 'ux/tickets/ticket-status',
  TICKETS = 'tickets',
  LEAD_DOCUMENT = 'lead-documents',
  UX_ASSINGNTO = 'ux/tickets',
  RAWLEAD_CUSTOMER_DETAILS = 'raw-leads-tasks/customer_details',
  SEND_NOTIFICATION = 'agreements/send-notification',
  AGREEMENT_TERM = 'agreement-term',
  ADDRESS_DETAILS = "address/find/afrigis",
  UX_LEAD_CATEGORY = "ux/lead/categories",
  SALES_API_UX_LEAD_CATEGORY = "ux/lead-categories",
  UX_LEAD_SOURCES_NEW = 'ux/lead-sources',
  SERVICE = 'service',
  UX_SERVICES = 'ux/service',
  UX_DESCRIPTION = 'ux/stock-description',
  SERVICE_MAPPING_DETAILS = "service-mappings/details",
  LEAD_NOTIFICATIONS_EMAIL = 'lead-notifications/email',
  LEAD_NOTIFICATIONS_SMS = 'lead-notifications/sms',
  SERVICECATEGORY = 'service-Category',
  LEAD_ASSIGNED_USER = 'lead-assigned-user',
  APPOINTMENT_TYPE = 'ux/appointment-types',
  APPOINTMENT_STATUS = 'ux/appointment-status',
  APPOINTMENT_SELLER = 'appointments/available-seller',
  AVAILABLE_SELLER = 'ux/available-seller',
  APPOINTMENT_SELLER_SAVE = 'appointments',
  LEADNOTES = 'lead-notes',
  APPOINTMENT = 'appointments',
  ARMING_DISARMING = "arming-disarming",
  APPOINTMENT_ESTMATIONTIME = 'appointments/seller/estimate-time',
  ARMING_DISARMING_LEAD_DETAILS = 'arming-disarming/lead/details',
  GET_OPEN_CLOSE_MONITORING = 'open-close-monitoring',
  GET_TOKEN = 'afrigis/token',
  GET_ADDRESS_FROM_AFRIGIS = 'afrigis/ux/address',
  POST_SELECTED_ADDRESS = 'address/details',
  AFRIGIS_ADDRESS_FOOTPRINT = 'afrigis/address/footprint',
  ADDRESS_ITEMS = 'address/items',
  BUILDINGSTRUCTURETYPE = 'ux/building-structure-type',
  ROOFTYPE = 'ux/roof-types',
  LEVYCONFIG = 'levy-config',
  LEAD_PROBABILITY = 'lead-probability',
  LEAD_CATEGORIES = 'lead/categories',
  SALES_API_LEAD_CATEGORIES = 'lead-categories',
  LEAD_ITEM_BY_ITEM = 'lead-item-by-item',
  STRUCTURE_TYPE = 'structure-type',
  STRUCTURE_TYPE_SAVE = 'structure-type/bulkInsert',
  ROOF_TYPE_SAVE = 'roof-type/bulkInsert',
  ROOF_TYPE = 'roof-type',
  UX_CONTRACT_PERIOD = 'ux/contract-period',
  UX_BILLING_INTERVALS = 'ux/billing-intervals',
  UX_BUILDING_STRUCTURE_TYPE = 'ux/building-structure-type',
  UX_AGREEMENT_OUTCOME = 'ux/agreement-outcome',
  SALES_API_UX_AGREEMENT_OUTCOME = 'ux/agreement-outcome',
  UX_AGREEMENT_OUTCOME_REASON = 'ux/agreement-outcome-reason',
  SALES_API_UX_AGREEMENT_OUTCOME_REASON = 'ux/agreement-outcome-reason',
  UX_ROOF_TYPES = 'ux/roof-types',
  LEVY_CONFIG_PERC_DETAILS = 'levy-config/percentage/details',
  UX_CONCESSION_TYPE = 'ux/concession/type',
  UX_CONCESSION_MOTIVATIONS = 'ux/concession-motivations',
  LEAD_CATEGORIES_UNMAPPED = "ux/lead/categories/un-mapped",
  RECENTTICKETS = 'recent-ticket',
  BANKING_ENABLE_DISABLE = 'debtor-banking',
  REASON_FOR_MOTIVATION = 'concession-motivations-detail',
  REASON_FOR_MOTIVATION_ACTION = 'concession-motivations',
  SALES_API_MOTIVATION_REASON = 'motivation-reasons',
  APPOINTMENTS = 'appointments',
  SERVICE_ITEM_CATEGORY_MAPPING = 'service-item-categories',
  SERVICE_ITEM_CATEGORIES = "service-item-categories",
  UX_SERVICE_ITEM_CATEGORIES = 'UX/service-item-categories',
  SERVICE_ITEM_CATEGORIES_DETAILS = 'service-item-categories/details',
  LEVY_CONFIG_PERCENTAGE = 'levy-config/percentage/details',
  AGREEMENT_OUTCOME = "agreement-outcome",
  SALES_API_AGREEMENT_OUTCOME = "agreement-outcome",
  AGREEMENT_OUTCOME_REASON = "agreement-outcome-reason",
  SALES_API_AGREEMENT_OUTCOME_REASON = "agreement-outcome-reason",
  AGREEMENT_OUTCOME_REASON_BY_OUTCOME_ID = "agreement-outcome/reason",
  SALES_API_AGREEMENT_OUTCOME_REASON_BY_OUTCOME_ID = "agreement-outcome/reason",
  DISCOUNT_REQUEST = 'discount-request',
  DISCOUNT_REQUEST_DETAILS = 'discount-request/details',
  HOLIDAY_INSTRUCTION_CONTACTS = 'holiday-instruction-contacts',
  HOLIDAY_INSTRUCTION = 'holiday-instructions',
  UX_SAFE_ENTRY = "ux/safe-entry",
  SAFE_ENTRY = "safe-entry",
  AGREEMENT_BY_CUSTOMER = "ux/agreements/by-customer",
  QUOTATION_VERSION_ACCEPT = "quotation-version/accept",
  UX_BILLING_FINANCIAL_PERIOD = "ux/run-date-config/financial-period",
  BILLING_FINANCIAL_YEAR_PERIOD_POPUP = "rundate-financialyear-details",
  UX_AGREEMENTTAB = "ux/agreement-tabs",
  SERVICE_AND_SERVICETABMAPPING = "service-tab-mapping",
  SERVICE_CATEGORIES_UNMAPPED = "ux/service-categories/un-mapped",
  COMMERCIAL_PRODUCTS = "commercial-products",
  CUSTOMER_GLOBAL_SEARCH = 'customer-global-search',
  GLOBAL_SEARCH = 'global-search',
  UX_CUSTOMER_STATUS = 'ux/customerstatus',
  UX_CUSTOMERSTATUS = 'ux/customer-status',
  ADVANCED_SEARCH = 'advanced-search',
  ADVANCED_SEARCH_CLIENT = 'advanced-search/clients',
  SEARCH_DEBTOR_CUSTOMER_DETAILS = 'search/debtor-customer-details',
  UX_REWARD_PARTNERS = 'ux/reward-partner',
  UX_CUSTOMER_TYPE = 'ux/customer-type',
  CUSTOMER_CALLBACK = "customer-callback",
  SCHEDULE_CALLBACK_CUSTOMERS = "schedule-callbacks/customers",
  CUSTOMER_CALLBACK_SNOOZE = "customer-callback/snooze",
  CUSTOMER_CALLBACK_ACCEPT = "customer-callback/accept",
  CUSTOMER_CALLBACK_CANCEL = "customer-callback/cancel",
  TICKETS_CUSTOMER = "ux/tickets-customer",
  CALLBACK_QUEUE = "ux/callback-queue",
  LEAD_CALLBACK = 'lead-callback',
  UX_COMMERCIAL_PRODUCT = "ux/commercial-products",
  UX_LSS_SCHEMES = 'ux/lss-schemes',
  LEAD_CATEGORY_SKILL = "lead-category-skill",
  UX_LEAD_CATEGORY_SKILL_MAPIING = "UX/lead-category-skill-mapping",
  SELLER_MATRIX = "seller-matrix",
  LAYER_NAME = "layers",
  SALES_CHANNEL = "sales-channel",
  SALES_API_SALES_CHANNEL = "sales-channels",
  CREDIT_VETTING_SCORE_CONFIG = "credit-vetting-score-config",
  SALES_API_CREDIT_VETTING_SCORE_CONFIG = "credit-vetting-score-config",
  UX_LEADGROUP_DISTRICT = 'ux/lead-groups-district',
  UX_SERVICE_BY_SERVICE_CATEGORY = 'ux/service/service-category',
  UX_SERVICE_CATEGORY_BY_SITE_TYPE = 'ux/service-category/site-types',
  PARTITIONS_ENABLED_DISABLED = 'partitions/enable-disable',
  CREATE_RAW_LEAD_NOTES = 'raw-lead-notes',
  RAW_LEAD_STATUSES = 'ux/raw-lead-status',
  RAW_LEAD_USER_GROUPS = 'ux/groups',
  RAW_LEAD_STATUS = "raw-lead-status",
  LEAD_SOURCE = 'lead-sources',
  LEAD_SOURCE_ENABLE_DISABLE = 'lead-sources/enable-disable',
  ASSIGN_TO_USER_GROUPS = 'ux/tickets',
  SKILL_CUTOFF = "skill-level-cutoff",
  GET_SKILLS = "skill-matrix",
  SELLER_SKILLS = 'skills',
  REWARD_CRITERIA = 'reward-criteria',
  REWARD_CRITERIA_VIEW = 'reward-discount',
  REWARD_PARTNER_GET = 'ux/reward-partners?id=1',
  REWARD_CONFIG_GET = 'ux/reward-config?Id=1',
  SELLER_PROFILE_SELLER_SKILLS = 'ux/skills',
  SELLER_PROFILE_SALES_CHANNELS = 'ux/sales-channels',
  SALES_API_SELLER_PROFILE_SALES_CHANNEL = 'sales-channels',
  SELLER_PROFILE_DISTRICTS = 'ux/seller/district',
  SELLER_PROFILE_SALES_AREA = 'ux/seller/sales-area/district',
  SELLER_PROFILE_REGIONS = 'ux/regions?CountryId=5AF34A38-AB5B-4A45-BC19-2F4486FABCD0',
  SELLER_PROFILE_SAVE = 'seller',
  SELLER_PROFILE_GET_EMPLOYEES = 'ux/seller',
  SELLER_PROFILE_GET_SELLERS = 'seller',
  CUSTOMER_ADDRESS = 'Customer/Address',
  LEAD_UPGRADE = 'leads/upgrade',
  REWARD_CRITERIA_UPDATE = 'reward-discount-update',
  SUPPORT_DOCUMENT_LIST = 'support-document',
  SUPPORT_FOLDER_LIST = 'customers/documents/folder-details',
  SALES_SUPPORT_FOLDER_LIST = 'documents/leads/quotations',
  SALES_SUPPORT_DOCUMENT = 'documents/leads',
  SUPPORT_DOCUMENT_UPLOAD = 'customer-support-document',
  CUSTOMER_DOCUMENTS = 'customers/documents',
  SUPPORT_DOCUMENT_DETAIL = 'customer/documents/details',
  SUPPORT_DEPARTMENT_LIST = 'ux/departments',
  SUPPORT_USRLEVEL_LIST = 'ux/user-levels',
  SUPPORT_DESIGNATIONS_LIST = 'ux/designations',
  SUPPORT_DESIGNATIONS_ROLES = 'roles',
  UX_ROLES_BY_DEPARMENTS = 'ux/role-department',
  SUPPORT_DOCUMENT_VIEW = 'sales-support-document',
  SUPPORT_DOCUMENT_TYPES = 'ux/customer-support-document',
  UX_REWARD_PARTNERS_REWARD = 'ux/reward-partner-reward',
  SCHEDULE_CALLBACK_SNOOZE = 'Snooze',
  CUSTOMER_ADDRESS_INFO = 'ux/customer/address',
  CURRENT_ADDRESS_INFO = 'address/active-subscriptions-items',
  CURRENT_ADDRESS_INFO_UPGRADE = 'address/upsell-active-subscriptions-items',
  CUSTOMER_ADDRESS_INFOLIST = 'ux/customer-address',
  CUSTOMER_DETAILS_BY_DEBTOR = 'customer-debtors/detail',
  CUSTOMER_DEBTOR_UPDATE = 'customer-debtors',
  CUSTOMER_ADDRESS_DETAILS = 'customer/current/information',
  GET_INSTALLED_SYSTEM = 'address/installed-items',
  CREATE_RELOCATION = 'leads/relocation',
  CREATE_RECONNECTION = 'leads/reconnection',
  VALIDATE_FOOTPRINT = 'relocation-validate-address',
  ACCOUNT_HOLDER_EXISTING_DEBTOR_DETAILS = 'account/holder/existing-debtor/details',
  GET_NEW_ADDRESS_ITEMS = 'address/items',
  STOP_KNOCK = 'stop-and-knock',
  PREMISE_STATUS = 'ux/stop-and-knock/premisestatus',
  SALES_API_SERVICE_PRICE = 'service-price',
  SALES_API_SERVICE_PRICE_SERVICE = "service-price-details",
  SALES_API_SERVICE_CATEGORY = 'service-categories',
  SALES_API_SERVICES = 'services',
  SALES_API_SERVICE_MAPPINGS = 'service-mappings',
  SALES_API_UX_SERVICE_CATEGORY = "ux/service-categories",
  SALES_API_SITE_TYPES = 'site-types',
  SALES_API_UX_SITE_TYPES = 'ux/site-types',
  SERVICE_PRICE_DROPDOWN = 'ux/service-price',
  SALES_API_SKILL_CUTOFF = "skill-level-cutoff",
  SALES_API_GET_SKILLS = "skill-matrix",
  SALES_API__MISCELLANEOUS__CONFIG = "miscellaneous-config",
  SALES_API__UX_MISCELLANEOUS__PRICE_TYPES = 'ux/miscellaneous-price-types',
  SALES_API_UX_TITLES = "ux/title",
  SALES_API_UX_SOURCE_TYPES = "ux/sources",
  SALES_API_OUTCOME = "outcome",
  SALES_API_UX_OUTCOME = "ux/outcome/all",
  SALES_API_OUTCOME_REASON = "outcome/reason",
  SALES_API_OUTCOME_HYPHEN_REASON = "outcome-reason",
  SALES_API_UX_ADDRESS = "ux/address",
  SALES_API_UX_NON_FIXED_ITEMS = "ux/items/non-fixed",
  SALES_API_ADDRESS_DETAILS = "address/details",
  SALES_API_LAT_LONGITUDE = "afrigis/reverse-geocode",
  SALES_API_LEADS = "leads",
  SALES_API_LEADS_COUNT = "lead-count",
  SALES_API_ALL_TICKETS_COUNT = "tickets/all-tickets-count",
  SALES_API_ROOF_TYPE = 'roof-types',
  SALES_API_ROOF_TYPE_SAVE = 'roof-types/bulkInsert',
  SALES_API_LEAD_SOURCE = 'sources',
  SALES_API_STRUCTURE_TYPE = 'structure-types',
  SALES_API_SOURCE_GROUPS = 'source-groups',
  SALES_API_UX_SERVICES = 'ux/services',
  SALES_API_UX_SERVICE = 'UX/services',
  SALES_API_SERVICE = 'services',
  SALES_API_RAW_LEADS = 'raw-leads',
  SALES_API_CREATE_RAW_LEAD_NOTES = 'raw-leads/notes',
  SALES_API_GET_ADDRESS_FROM_AFRIGIS = 'ux/address',
  SALES_API_RAW_LEAD_STATUSES = 'ux/raw-lead-status',
  SALES_API_LEAD_STATUSES = 'ux/lead-status',
  SALES_API_SOURCES = 'sources',
  SALES_API_CITIES = 'ux/cities/autocomplete',
  SALES_API_SUBURBS = 'ux/suburbs/autocomplete',
  SALES_API_NEW_ADDRESS = 'raw-leads/new-address-request',
  SALES_API_DUPLICATE_LEADS = 'leads/validate/open-leads',
  UX_SERVICE_PRICE_SERVICE_CATEGORIES = "ux/service-price/service-categories",
  UX_SERVICE_PRICE_SERVICES = "ux/service-price/services",
  SALES_API_SERVICE_ITEMS = 'service-items',
  SALES_API_STRUCTURE_AND_ROOF_TYPE = 'structure-and-roof-type-mapping',
  SALES_API_ROOFTYPE = 'ux/roof-types',
  SALES_API_BUILDINGSTRUCTURETYPE = 'ux/structure-types',
  SALES_API_LEADS_MY_LEADS = 'leads/my-leads',
  SALES_API_LEADS_LANDING = "lead-landing",
  SALES_API_LEADS_HEADER = "leads/header",
  SALES_API_COMMERCIAL_PRODUCTS = "commercial-products",
  SALES_API_CONTACT_NUMBER = 'leads/phone-no',
  SALES_API_UX_CONTRACT_PERIODS = 'ux/contract-periods',
  SALES_API_LEAD_ASSIGNED_USER = 'lead-assigned-users',
  SALES_API_UX_PARTITION_TYPES = 'ux/partition-types',
  SALES_API_LEAD_SERVICES = 'lead/services',
  SALES_API_STATUSES = 'ux/raw-lead-status/restricted',
  SALES_API_RAW_LEAD_STATUS = 'raw-leads/change-status',
  SALES_API_LEAD_NOTIFICATIONS_EMAIL = 'email-notifications',
  SALES_API_LEAD_NOTIFICATIONS_SMS = 'sms-notifications',
  SALES_API_LEAD_CALLBACK = 'lead-callbacks',
  SALES_API_LEAD_CALLBACK_SNOOZE = 'lead-callbacks/snooze',
  SALES_API_LEAD_CALLBACK__ACCEPT = 'lead-callbacks/accept',
  SALES_API_LEAD_CALLBACK__CANCEL = 'lead-callbacks/cancel',
  SALES_API_USERS_FROM_GROUP = 'ux/users',
  SALES_API_STOCK_ITEMS_DROPDOWNS = 'ux/leads/stock/items',
  SALES_API_LEAD_SERVICES_BY_ID = 'lead-services',
  SALES_API_PARTITION_SEARCH = 'partition-search',
  SALES_API_STOCK_ITEMS_DATA = 'leads/stock/items',
  SALS_API_LEAD_STATUS = "ux/raw-lead-status/restricted",
  SALES_API_MY_RAW_LEADS = 'raw-leads/my-raw-leads',
  SALES_API_LEAD_NOTES = 'lead-notes',
  SALES_API_LEAD_GROUPS = 'ux/lead-groups/link',
  SALES_API_REWARD_PARTNERSHIPS = 'reward-partnerships',
  SALES_API_FIXED_PERIODS = 'ux/fixed-contract-fee-periods',
  SALES_API_ANNUAL_PERIODS = 'ux/annual-network-fee-periods',
  SALES_API_ANNUAL_COMPLI_PERIODS = 'ux/complimentary-months',
  SALES_API_REWARD_PARTNERSHIP_SERVICES = 'reward-partnership-services',
  SALES_API_MISCELLANEOUS_CONFIG_PRICE = 'miscellaneous-config/price-types',
  SALES_API_REAWARD_ITEM_INFO = 'reward-partnership-items',
  SALES_API_LSS = "lss",
  SALES_API_LSS_REGISTRATION = 'lss-registrations',
  SALES_API_LSS_TYPES = 'ux/lss-types',
  SALES_API_LSS_PRICING = 'lss-items-prices',
  SALES_API_LSS_SCHEME_TYPES = 'ux/lss-types',
  SALES_API_LSS_TYPES_API = 'lss-types',
  SALES_API_RESOURCES = 'lss-resources',
  SALES_API_CONTRIBUTION_TYPE = 'ux/lss-contribution-types',
  SALES_API_LSS_CLIENT_TYPE = 'ux/lss-client-types',
  SALES_API_LSS_CONTACTS = 'lss-contacts',
  SALES_API_UX_LSS_GRADES = 'ux/lss-grades',
  SALES_API_LSS_SERVICE_PRICE = 'lss-service-prices',
  SALES_API_LSS_SHIFTS = 'lss-shifts',
  LSS_CONTACT_DOCUMENTS = 'documents',
  UX_LSS_CUSTOMERS = 'ux/lss/customers',
  LSS_SECTION_CUSTOMERS = 'lss/section21-customers',
  LSS_DOCUMENTS = 'lss/documents',
  LSS_SERVICE_PRICE = 'lss-service-prices',
  LSS_SERVICE_PRICE_STOCKS = 'lss-service-prices-stocks',
  LSS_VEHICLES = 'lss-vehicle',
  SALES_API_BOUNDARY_LAYERS = 'ux/boundary-layers',
  SALES_API_GIS_BOUNDARY = 'boundaries',
  SALES_API_GIS_BOUNDARY_DETAILS = 'boundaries/details',
  SALES_API_BOUNDARIES = 'ux/boundaries',
  SALES_API_BOUNDARIES_DISTRICT = 'ux/boundaries/district',
  SALES_API_GET_DOWNLOADABLE_FILES = 'raw-leads/download/file',
  SALES_API_NO_REASON = 'outcome-reasons',
  SALES_API_RAW_LEADS_CONVERT_LEAD = 'raw-leads/convert-lead',
  SALES_API_KEY_HOLDERS = 'key-holders',
  SALES_API_EMERGENCY_CONTACTS = 'emergency-contacts',
  SALES_API_DOMESTIC_WORKERS = 'domestic-workers',
  SALES_API_DOMESTIC_DETAILS = 'domestic-workers/domestic/details',
  SALES_API_UX_TYPE_OF_WORKERS = 'ux/type-of-workers',
  SALES_API_GET_QUOTATIONS = 'quotations',
  SALES_API_PRICE_ADJUSTMENTS = 'quote-price-adjustments',
  SALES_API_PROBABILITY_CLOSURE = 'ux/probability-closure',
  SALES_API_UX_MOTIVATION_REASON = 'ux/motivation-reasons',
  SALES_API_UX_NEWS_LETTER_TYPES = 'ux/news-letter-types',
  SALES_API_QUOTATION_OUTCOME_NO_SALE = 'quotations/outcome/no-sale',
  ONLINE_QUOTATION_OUTCOME_DECLINE = 'quotations/online-acceptance/decline',
  SALES_API_QUOTE_FOLLOW_UPS = "quote-follow-ups",
  SALES_API_LEAD_CONTACTS = "lead-callbacks/lead-contacts",
  SALES_API_UX_REWARD_PARTNERSHIP = 'ux/reward-partnerships',
  SALES_API_QUOTATION_OUTCOME_PENDING = 'quotations/outcome/pending',
  SALES_API_QUOTATION_OUTCOME_ACCEPT = 'quotations/outcome/accept',
  SALES_API_QUOTATION_OUTCOME_DECLINE = 'quotations/quotation/decline',
  SALES_API_QUOTATION_OUTCOME_DECLINE_ALL = 'quotations/outcome/decline-all',
  SALES_API_UX_OUTCOME_REASON = 'ux/outcome-reasons',
  SALES_API_SITE_HAZARD_SERVICES = 'site-hazards/services',
  SALES_API_CELL_PANIC = 'cell-panic',
  SALES_API_UX_DOG_TYPES = 'ux/static',
  SALES_API_DELETE_DOG_TYPES = 'dog-types',
  SALES_API_DELETE_MEDICAL = 'special-instructions/medical-conditions',
  SALES_API_SITE_HAZARD_INSTALLATION = 'site-hazards/installations',
  SALES_API_DELETE_DIGIPAD = 'access-premises/digipad',
  SALES_API_DELETE_LOCKBOX = 'access-premises/lockbox',
  SALES_API_TERMS = 'service-and-installation-terms-and-conditions',
  SALES_API_FINDU = 'findu-users',
  SALES_API_DEBTOR_LEADS = 'debtor/leads',
  SALES_API_DEBTOR_BANKING = 'debtor-banking',
  SALES_API_DEBTOR_BANKING_V1 = 'debtor-banking/v1',
  SALES_API_SEARCH_DEBTER = 'debtor/search',
  SALES_API_CREATE_DEBTER = 'debtors',
  SALES_API_UX_TICKETTYPES = 'ux/ticket-groups',
  SALES_API_BANKS = 'ux/banks',
  SALES_API_DEBTER_DETAILS = 'debtor-details',
  SALES_API_UX_STATIC = 'ux/static',
  SALES_API_UX_DYNAMIC = 'ux/dynamic',
  SALES_API_OPS_MANAGEMENT = 'ops-management-types',
  DELETE_OPENCLOSE_CONTACT = 'open-close-monitoring/contacts',
  BANKS = 'banks',
  BANK_BRANCH_DETAILS = 'banks-branch-details',
  BANK_BRANCHS = 'bank-branches',
  SALES_API_MAIN_AREA = "main-areas",
  SALES_API_UX_MAIN_AREA = "ux/main-areas",
  SALES_API_UX_SUB_AREA = 'ux/sub-areas',
  SALES_API_UX_SUB_AREA_SEARCH = 'ux/sub-areas/search',
  SALES_API_SUB_AREA = "boundaries/operations",
  SALES_API_OPS_UX = 'ux/ops-management-types',
  SALES_API_UX_SUB_BRANCHES = 'ux/sub-branches',
  SALES_API_SALES_BOUNDARIES = 'sales-boundaries',
  SALES_API_SALES_BOUNDARIES_DETAILS = 'sales-boundaries/details',
  COMMS_TYPES = 'comms-types',
  SALES_API_BOUNDARY_GIS_DETAILS = 'boundaries/gis/details',
  ACCOUNT_TYPES = 'account-types',
  CANCEL_REASON_CODES = 'cancel-reason-codes',
  SUSPENSION_REASON_CODE = 'suspension-reason-codes',
  DEBITVALUE_TYPES = 'debitvalue-types',
  DEBIT_ENTRY_CLASS_CODES = 'debit-entry-class-code',
  DEBTOR_AUTHENTICATION_CODE = 'debtor-authentication-code',
  MANDATE_FREQUENCY_CODE = 'mandate-frequency-code',
  ENTRY_CLASS_CODE = "entry-class-code",
  BANK_RESPONSE_CODE = "response-codes",
  SALES_API_CONTRACTS = 'contracts',
  SALES_PROCESS_SALES = 'process-sales',
  SALES_API_GET_SERVICE_FEE = 'service-fees',
  SALES_API_VALIDATE_DEBTOR = 'process-sales/validate-debtor',
  SALES_API_SALES_ORDER = 'sales-orders',
  SALES_API_SALES_DOCUMENT_ORDER = 'customers/documents/sales-orders',
  SALES_API_UX_INSTALLATION = 'UX/installation-fees',
  SALES_API_GET_INSTALLATION_FEE = 'installation-fees',
  SUMMARY = 'payment-summary',
  SALES_API_BOUNDARIES_MY_REQUEST = 'boundaries/my-request',
  SALES_API_BOUNDARIES_ALL_REQUEST = 'boundaries/request/all',
  SALES_API_BOUNDARIES_GIS_DETAILS = 'boundaries/gis/details',
  SALES_API_BOUNDARIES_GIS = 'boundaries/gis',
  SALES_API_BOUNDARIES_GIS_APPROVE = 'boundaries/gis/approve',
  SALES_API_BOUNDARIES_GIS_DECLINE = 'boundaries/gis/decline',
  SALES_API_REASON_FOR_MOTIVATION_TYPES = 'ux/motivation-reason-types',
  SALES_API_BOUNDARY_DETAILS = 'boundaries/operations/details',
  SALES_ORDER = 'sales-orders',
  POST_SUBSCRIPTIONS = 'Subscriptions',
  INVOICE = 'invoice',
  SALES_API_EMPLOYEE_LISTING = 'employees',
  SALES_API_EMPLOYEE_DETAILS = 'employee-detail',
  SALES_API_EMPLOYEE_DUPLICATION = 'employee-no-validation',
  PARTITIONS_COUNT = "partitions/count",
  TECH_AREA_BOUNDARY = "techarea-boundaries",
  TECH_AREA_BOUNDARY_DETAILS = "techarea-boundaries/details",
  EMPLOYEE_AUDIT = "employee-audit-detail",
  ACCEPT_CUSTOMER_DETAILS = "quotations/accept-customers-details",
  QUOTATION_ONLINE_ACCEPTENCE = "quotations/online-acceptance",
  GIS_BOUNDARIES_DOWNLOAD = 'boundaries/gis/download',
  GIS_BOUNDARIES_UPLOAD = 'boundaries/gis/upload',
  BOUNDARIES_GIS_DASHBOARD = 'boundaries/gis-dashboard',
  CALL_INITIATION = "call-initiation",
  SIGNAL_CALL_INITIATION = "signal-call-initiation",
  INSTALLATION_GET_METHOD = "installation",
  FILE_UPLOAD = 'file-upload',
  SALES_API_SUBSCRIPTIONS = 'ux/customer/subscriptions',
  SALES_API_CUSTOMER_BANKING = 'customer-debtors/banking',
  LEADS_CUSTOMER_ADDRESS = 'leads/customer-address',
  CUSTOMER_DEBTOR = 'customer-debtor',
  CUSTOMER_DEBTOR_ADDRESS = 'customer-debtor-address',
  CUSTOMER_DEBTOR_LIST = 'customer-debtors/address',
  PAYMENT_TRANSACTION_LIST = 'payment-transaction',
  PAYMENT_TRANSACTION_LIST_BETA = 'payment-transaction-beta',
  REFER_TO_SALES = 'refer-to-sales',
  REFER_TO_SALES_COMPLETE = 'refer-to-sales-complete',
  CUSTOMER_DOCS = 'customer/documents',
  PENDING_TRANSACTION_LIST = 'pending-transaction',
  PENDING_TRANSACTION_LIST_BETA = 'pending-transaction-beta',
  UX_DORUN = 'ux/debit-order-run-codes',
  LSS_LEAD_SERVICES = 'lead-services/lss/{LeadId}',
  LEAD_SERVICES_LSS = 'lead-services/lss',
  LEAD_SERVICES_LSS_DROPDOWN = 'ux/lead-services/lss',
  UX_CONTACT_TYPE_PERSONS = 'ux/contact-person-types',
  STOP_AND_KNOCK_ASSIGN_AGENT = 'stop-and-knock/assign-agent',
  STOP_AND_KNOCK_ADD_NOTES = 'stop-and-knock/notes',
  STOP_AND_KNOCK_SCHEDULE_CALLBACK = 'stop-and-knock/schedule-follow-up',
  STOP_AND_KNOCK_CUSTOMER = 'stop-and-knock/Customer',
  STOP_AND_KNOCK_REMOVE_EQUIPMENT = 'stop-and-knock/remove-equipment',
  CUSTOMER_CONTACT__GET_UPDATE = 'customers/contact-details',
  CUSTOMER_CONTACT_UPDATE = 'customers/contact-info',
  DEBTOR_ACCEPTANCE_DETAILS = 'debtor-quotes-details',
  DEBTOR_ACCEPTANCE_UPDATE = 'debtor-online-acceptance',
  DEBTOR_CALLBACK = 'debtor-callbacks',
  CREDIT_VETTING = 'credit-vetting',
  CREDIT_VETTING_V1 = 'credit-vetting/v1',
  CREDIT_VETTING_DOCUMENT = 'credit-vetting-document',
  CREDIT_RESULT = 'credit-vetting/score',
  APPOINTMENTS_RESCHEDULE = 'appointments/reschedule',
  CALL_REASON_CODE = 'call-reasons',
  UX_ADDRESS = 'ux/address',
  SALES_API_LEAD_HAND_OVER_CERTIFICATE = 'lead-hand-over-certificate',
  SALES_API_LEAD_HAND_OVER_CERTIFICATE_CALL_ID = 'lead-hand-over-certificate/callid',
  DOCUMENT_BLOB = 'document-blob',
  SALES_API_LEAD_HAND_OVER_CERTIFICATE_DOCUMENT = 'lead-hand-over-certificate/document',
  SALES_API_CERTIFICATE_CALLID = 'lead-hand-over-certificate/callid',
  SALES_BOUNDARIES_IMPORT = 'boundaries/sales/import',
  TECHNICAL_BOUNDARIES_IMPORT = 'boundaries/technical/import',
  OPERATIONS_BOUNDARIES_IMPORT = 'boundaries/operations/import',
  BOUNDARIES_MAP_VIEW = 'boundaries/map-view/import',
  OTHER_BOUNDARIES_IMPORT = 'boundaries/other-type',
  OTHER_BOUNDARY_IMPORT_DETAIL = 'boundaries/other-type/details',
  OTHER_BOUNDARIES_FILE_IMPORT = 'boundaries/saps/import',
  BOUNDARIES_OWNER_DETAILS = 'boundaries/owner-details',
  CREDIT_VETTING_PAYMENT_PROOF = 'credit-vetting/payment-proof',
  DOA_CONFIG_LEVEL = 'doa-config',
  DOA_LIMIT_CONFIG = 'doa-limit-config',
  UX_PAYMENT_CHANGE_METHOD = 'ux/changing-payment-method',
  GET_LEAD_BY_CUSTOMER_ID = 'leads/customer',
  UX_CALL_AGENT = 'ux/calls/agent',
  CALL_HISTORY = 'calls/call-history',
  CALL_NOTES_REASON_SUBREASON = 'ux/call-notes/reason-subreason',
  CALL_NOTES = 'call-notes',
  MY_CALLS = 'calls/my-calls',
  STATEMENT_FEE_SAVE = 'customer-debtors/statment-fee',
  CHANGING_PAYMENT_METHOD = 'changing-payment-method',
  UX_STATIC = 'ux/static',
  UX_DOA_LIMIT_CONFIG = 'ux/doa-limit-config',
  LIMIT_CONFIG_DETAILS = 'doa-limit-config-detail',
  SERVICE_AGREEMENT_CONTRACT_TERMS_AND_CONDITIONS = 'service-agreement-terms-and-conditions-web',
  INSTALLATION_AGREEMENT_CONTRACT_TERMS_AND_CONDITIONS = 'installation-agreement-terms-and-conditions-web',
  DOA_LEVEL_PRICE_ADJUSTMENT = 'quote-price-adjustments/doa-level',
  DOA_DASHBOARD = 'doa-dashboard',
  ADVANCED_SEARCH_DEBTORS = 'advanced-search/debtors',
  UX_DEBTOR_STATUS = 'ux/debtor-status',
  INSTALLATION_INSTRUCTIONS = 'installation-instructions',
  DOA_BOUNDARY_APPROVAL = 'doa-boundary-approval',
  BOUNDARY_APPROVALS = 'boundary-approvals',
  APPROVER_CONFIG_EMPLOYEE = 'approver-config-employee',
  UX_BRANCH_ROLES = 'ux/branch-roles',
  RAW_LEADS_NEW_ADDRESS_REQUESTS = 'raw-leads-new-address-request',
  BOUNDARY_NOTES = 'boundaries/notes',
  UX_DIVISION_BRANCHES = 'ux/division-branches',
  BOUNDARIES_UPDATE_BOUNDARY = 'boundaries/update-boundary',
  UX_DEBTORS = 'ux/debtors',
  UX_BUSINESS_AREA = 'ux/business-areas',
  UX_BUSINESS_AREA_MULTIPLE = 'ux/business-area-multiple',
  UX_MAIN_AREA_BY_BRANCH = 'ux/main-areas-by-branch',
  DOA_DASHBOARD_LIST = 'doa-dashboard-list',
  DOA_DASHBOARD_APPROVE = 'doa-dashboard/approve',
  LSS_CONTRIBUTION = 'lead-lss-contribution-delete',
  DOA_DASHBOARD_DECLINE = 'doa-dashboard/decline',
  DOA_DASHBOARD_ESCALATE = 'doa-dashboard/escalate',
  UX_LICENCE_TYPES = 'ux/leads/license-types',
  AREA_SETUP_CONFIG = 'area-setup-config',
  COUNTER_SALE = 'direct-sales',
  COUNTER_SALES_CITIES = 'ux/cities',
  COUNTER_SALES_SUBURUBS = 'ux/suburbs',
  DIRECT_SALES_HEADER_DETAILS = 'direct-sale-header-details',
  DIRECT_SALES_ITEMS = 'direct-sale-items',
  DIRECT_SALES_ITEMS_GET_DETAILS = 'direct-sale-items-details',
  DIRECT_SALES_ITEMS_LABOUR_PRICE = 'direct-sale-items/labour-price',
  DIRECT_SALES_DELETE_SYSTEM_TYPE = 'direct-sale-system-types',
  DIRECT_SALES_QUOTATION_LIST = 'direct-sale-quotation-list',
  DIRECT_SALES_QUOTATION_DECLINE = 'direct-sale-quotation-decline',
  DIRECT_SALES_QUOTATION_ACCEPT = 'direct-sale-quotation',
  DIRECT_SALES_QUOTATION_DETAILS = 'direct-sale-quotation-details',
  DOCUMENT_LIST = 'document-list',
  DIRECT_SALES_DOCUMENT_UPLOAD = 'documents',
  VALIDATE_CUSTOMER = 'credit-vetting/it-numbers',
  COUNTER_SALES_DOCUMENT_DETAILS = 'document-details',
  BOUNDARIES_GO_LIVE_NOTIFICATION = 'boundaries/go-live-notification',
  GO_LIVE_BOUNDARIES_TERMINATE = 'boundaries/terminate-changes',
  DECLINE_DEBTOR = 'debtor-online-decline',
  UPSELL_QUOTE_HEADER_DETAILS = 'upselling/customer-header-details',
  UPSEL_CUSTOMER_REQUESTED_BY = 'ux/upselling/customer-requestedby',
  INSTALLATION_FEES_EMAIL = 'installation-fees/email',
  FINDU_VALIDATION = 'findu/email-validate',
  INVOICE_PAYMENT_UPSELL_QUOTE = 'direct-sales-payment/on-invoice',
  DO_PAYMENT_UPSELL_QUOTE = 'direct-sales-payment/debit-order',
  DIRECT_SALES_PAYMENT = 'direct-sales-payment/amount-validate',
  CREATE_JOB = 'upselling-service-call-initiation',
  CREATE_APPOINTMENT = 'upselling-appointments',
  LSS_BOUNDARY_APPROVAL = 'boundaries/lss/approve',
  LSS_BOUNDARY_DECLINE = 'boundaries/lss/decline',
  INVOICE_PAYMENT_COUNTER_SALE = 'direct-sales-payment/counter-sale',
  UPSELL_QUOTE_ACCEPTANCE_DETAILS = 'direct-sale-quotation/quote-acceptance-details',
  UPSELL_QUOTE_ACCEPT = 'direct-sale-quotation/online-acceptance',
  UPSELL_QUOTE_DECLINE = 'direct-sale-quotation/online-acceptance/decline',
  UPSELLING_LIST = 'upselling/list',
  TICKET_PRIORITY = 'ux/tickets/ticket-priority',
  TICKET_FLAG = 'ux/tickets/ticket-flag',
  ALL_TICKETS = 'tickets/all-tickets',
  ALL_FILTERED_TICKETS = 'tickets/filtered-all-tickets',
  ALL_FILTERED_TICKETS_COUNTS = 'tickets/filtered-all-tickets-count',
  MY_TICKETS = 'tickets/my-tickets',
  ESCALATE_TICKET = 'tickets/escalated-tickets',
  RESOLVE_ESCALATION = 'tickets/ticket-resolve',
  ESCALATION_CONFIG = 'tickets-escalation-configuration',
  USERS_BY_ROLE = 'ux/role-users',
  UX_TICKET_ESCALATION_USER_RELATION = 'ux/ticket-escalation-user-relation',
  ESCALATION_PROCESS = 'tickets-escalation-configuration',
  FLAG_UPDATE = 'tickets/ticket-flag',
  ESCALATION_DETAILS = 'tickets-escalation-configuration/detail',
  UPSELL_DOCUMENT_LIST = 'upselling/document-list',
  UPSELL_DOCUMENT_UPLOAD = 'upselling/document-insert',
  TECHNICAL_UPSELLING_REQUESTEDBY_CONTACT = 'technical-upselling-requestedby-contact',
  BOUNDARY_DOWNLOAD = 'boundary-download',
  UPSELL_QUOTE_PENDING = 'direct-sale-quotation/outcome/pending',
  UPSELL_QUOTE_NO_SALE = 'direct-sale-quotation/outcome/no-sale',
  SERVICE_BOUNDARY_LAYER = 'service-boundary-layer',
  ROLLBACK_BOUNDARIES = 'boundaries/backup-dashboard',
  ROLLBACK_BOUNDARIES_DETAIL = 'boundaries/backup/details',
  INITIATE_ROLLBACK = 'boundaries/initiate-rollback',
  SALES_API_CUSTOM_ADDRESS = 'lead-custom-address',
  ADDRESS_VALIDATORS_ROLE_CONFIG = 'address-validators-role-config',
  ADDRESS_VALIDATORS_ROLE_CONFIG_DETAILS = 'address-validators-role-config/detail',
  VALIDATE_ADDRESS_LIST = 'address-validators-role-assigned',
  CUSTOM_ADDRESS = 'custom-address',
  CUSTOM_ADDRESS_DETAILS = 'custom-address/detail',
  UX_ADDRESS_CONFIDENT_LEVEL = 'ux/address-confidence-level',
  VIEW_VALIDATORS = 'address-validators/detail',
  IMPACTED_CUSTOMERS = 'boundaries/impacted-customers',
  BOUNDARIES = 'boundaries',
  CUSTOMER_IDENTIFICATION = 'agreement-tabs/customer-identification',
  SALE_COMPLETED = 'sale-completed',
  PAYMENT_DATE_VALIDATE = 'validate-debit-date',
  APPOINTMENT_CANCEL = 'appointments/cancel',
  CALL_REASONS = 'call-reasons',
  UX_CALL_REASONS = 'ux/call-reasons',
  CALL_WRAPUP_REASON = 'call-wrapup-reason',
  UX_WRAPUP_REASONS = 'ux/wrapup-reasons',
  LINK_CALL_CUSTOMER = 'calls/link-call-customer',
  CLIENT_QUOTES = 'client-quotes',
  CUSTOMER_CALL_HISTORY = 'calls/customer',
  DEBTOR_AVS_VERIFICATION = 'debtor-avs/verification',
  UX_SUBSCRIPTION_CANCEL_CONTRACTS = 'ux/subscription-cancel/contracts',
  UX_SUBSCRIPTION_CANCEL_CONTRACT_TICKETS = 'ux/subscription-cancel/contract-tickets',
  OPPOSITION = 'opposition',
  OPPOSITION_DETAIL = 'opposition/detail',
  UX_OPPOSITION = 'ux/opposition',
  OPPOSITION_REASON = 'opposition-reason',
  OPPOSITION_REASON_DETAIL = 'opposition-reason/detail',
  UX_OPPOSITION_REASON = 'ux/opposition-reason',
  SUBSCRIPTION_CANCEL = 'subscription-cancel',
  SUBSCRIPTION_CANCEL_CANCEL_REQUEST = 'subscription-cancel/cancel-request',
  SUBSCRIPTION_CANCEL_DETAIL = 'subscription-cancel/detail',
  SUBSCRIPTION_CANCEL_TICKET_DOCUMENTS = 'subscription-cancel/ticket-documents',
  SUBSCRIPTION_CANCEL_CONTRACT_DETAIL = 'subscription-cancel/contract-detail',
  SUBSCRIPTION_CANCEL_CONTRACT_DETAIL_ALL = 'subscription-cancel/contract-detail-all',
  CUSTOMER_CALL_VERIFICATION = 'customer-verification/call-log-details',
  QUOTATION_ITEMS = 'quotation-items',
  LEAD_HAND_OVER_CERTIFICATE = 'lead-hand-over-certificate',
  SUBSCRIPTION_CANCEL_UPGRADE = 'subscription-cancel-upgrade',
  SUBSCRIPTION_CANCEL_UPGRADE_DETAIL = 'subscription-cancel-upgrade/detail',
  SUBSCRIPTION_CANCEL_UPGRADE_ADJUST_COSTING_DETAIL = 'subscription-cancel-upgrade/adjust-costing-detail',
  SUBSCRIPTION_CANCEL_UPGRADE_ADJUST_COSTING = 'subscription-cancel-upgrade/adjsut-costing',
  SUBSCRIPTION_CANCEL_UPGRADE_SUMMARY_DETAIL = 'subscription-cancel-upgrade/service-summary-detail',
  SUBSCRIPTION_CANCEL_UPGRADE_COMPARISON_SUMMARY = 'subscription-cancel-upgrade/service-comparison-summary',
  SUBSCRIPTION_CANCEL_UPGRADE_ACCEPT_CONTRACT = 'subscription-cancel-upgrade/accept-revised-contract',
  SUBSCRIPTION_CANCEL_UPGRADE_DOA_DECLINED = 'subscription-cancel-upgrade/doa-declined',
  SUBSCRIPTION_CANCEL_UPGRADE_SERVICES = 'subscription-cancel-upgrade/services',
  SUBSCRIPTION_CANCEL_UPGRADE_DOA_APPROVE_LIST = 'subscription-cancel-upgrade/doa-approval-list',
  SUBSCRIPTION_CANCEL_UPGRADE_DOA_CONFIG_DETAIL = 'subscription-cancel-upgrade/doa-config-detail',
  SUBSCRIPTION_CANCEL_UPGRADE_LSS_DETAIL = 'subscription-cancel-upgrade/lss-detail',
  SUBSCRIPTION_CANCEL_UPGRADE_LSS = 'subscription-cancel-upgrade/lss',
  SUBSCRIPTION_CANCEL_UPGRADE_DOA_APPROVAL = 'subscription-cancel-upgrade/doa-approval',
  SUBSCRIPTION_CANCEL_DOWNGRADE = 'subscription-cancel-downgrade',
  SUBSCRIPTION_CANCEL_DOWNGRADE_DETAIL = 'subscription-cancel-downgrade/detail',
  SUBSCRIPTION_CANCEL_DOWNGRADE_ADJUST_COSTING_DETAIL = 'subscription-cancel-downgrade/adjust-costing-detail',
  SUBSCRIPTION_CANCEL_DOWNGRADE_ADJUST_COSTING = 'subscription-cancel-downgrade/adjsut-costing',
  SUBSCRIPTION_CANCEL_DOWNGRADE_SUMMARY_DETAIL = 'subscription-cancel-downgrade/service-summary-detail',
  SUBSCRIPTION_CANCEL_DOWNGRADE_COMPARISON_SUMMARY = 'subscription-cancel-downgrade/service-comparison-summary',
  SUBSCRIPTION_CANCEL_DOWNGRADE_ACCEPT_CONTRACT = 'subscription-cancel-downgrade/accept-revised-contract',
  SUBSCRIPTION_CANCEL_DOWNGRADE_DOA_DECLINED = 'subscription-cancel-downgrade/doa-declined',
  SUBSCRIPTION_CANCEL_DOWNGRADE_SERVICES = 'subscription-cancel-downgrade/services',
  SUBSCRIPTION_CANCEL_DOWNGRADE_LSS = 'subscription-cancel-downgrade/lss',
  SUBSCRIPTION_CANCEL_DOWNGRADE_DOA_APPROVAL = 'subscription-cancel-downgrade/doa-approval',
  SALES_ORDER_PAYMENT_Insert = 'sale-order-payment-insert',
  SERVICE_SUSPEND_REASON = 'service-suspend-reason',
  SERVICE_SUSPEND_REASON_DETAIL = 'service-suspend-reason/detail',
  UX_SERVICE_SUSPEND_REASON = 'ux/service-suspend-reason',
  SERVICE_SUSPEND_SUB_REASON = 'service-suspend-sub-reason',
  SERVICE_SUSPEND_SUB_REASON_DETAIL = 'service-suspend-sub-reason/detail',
  UX_SERVICE_SUSPEND_SUB_REASON = 'ux/service-suspend-sub-reason',
  SUBSCRIPTION_SUSPEND = 'subscription-suspend',
  SUBSCRIPTION_SUSPEND_DETAIL = 'subscription-suspend/detail',
  POTENTIAL_SUBSCRIPTION_SUSPEND_DETAIL_REINSTATEMENT = 'potential-subscription-suspend/detail',
  SUBSCRIPTION_SUSPEND_RETRACT_SUBSCRIPTION = 'subscription-suspend/retract-subscription',
  SUBSCRIPTION_SUSPEND_REINSTATE_SUBSCRIPTION = 'subscription-suspend/reinstate-subscription',
  SUBSCRIPTION_SUSPEND_TICKETS = 'subscription-suspend/tickets',
  SUBSCRIPTION_SUSPEND_UPGRADE = 'subscription-suspend/upgrade',
  SERVICE_SUSPEND_DOA_CONFIG = 'service-suspend-doa-config',
  SERVICE_SUSPEND_DOA_CONFIG_DETAIL = 'service-suspend-doa-config/detail',
  SERVICE_SUSPEND_DOA_APPROVAL_LIST = 'subscription-suspend/doa-approval-list',
  SERVICE_SUSPEND_DOA_APPROVAL = 'subscription-suspend/doa-approval',
  POTENTIAL_SUBSCRIPTION_SUSPEND_DOA_APPROVAL = 'potential-subscription-suspend-instate/doa-approval',
  SERVICE_SUSPEND_DOA_DECLINE = 'subscription-suspend/doa-decline',
  SALES_AREA_LAYER = 'sales-area-layer',
  DIRECT_SALES_EXCEPTION_CONFIG = 'direct-sales-payment/exception-config',
  DIRECT_SALES_EXCEPTION_CONFIG_LIST = 'direct-sales-payment/exception-config-list',
  UX_TICKET_DEPARTMENT = 'ux/ticket-groups-without-type',
  UX_TICKET_GROUP = 'ux/ticket-types-by-group',
  UX_SERVICE_PARTITIONS = 'ux/service-partition',
  BALANCE_OF_CONTRACTS_WAIVE_FEE_DETAILS = 'balance-of-contract-waive-fee-details',
  UPSELL_QUOTE_QUOTATION_LIST = 'upsell-quote-quotation-list',
  CONTRACT_PERIOD_CONFIGURATION = 'contract-periods',
  UX_BOC_CUSTOMER = 'ux/boc/customer',
  LEAD_BOC_CUSTOMER = 'lead-balance-of-contract/customer',
  LEAD_BOC_CONTRACT = 'lead-balance-of-contract/contract',
  LEAD_BOC_CONTRACT_DETAIL = 'lead-balance-of-contract/contract/detail',
  LEAD_BALANCE_OF_CONTRACT = 'lead-balance-of-contract',
  DIRECT_SALE_ITEM_DOA_TASKLIST_DETAILS = 'direct-sale-items/doa-tasklist-details',
  DIRECT_SALE_ITEM_DOA_TASKLIST_APPROVE = 'direct-sale-items/doa-tasklist-approve',
  ADVANCED_SEARCH_CUSTOMER_CONTRACT_DEBTORS = 'advanced-search/customer-contract-debtors',
  MARKETING_DATA_SYNC_DASHBOARD = 'marketing-data-sync-maintainance',
  UX_MARKETING_DAYS = 'ux/days',
  UX_MARKETING_MAINTAINCE_DATA = 'ux/marketing-data-sync-maintainance-update-types',
  UX_MARKETING_TESTRUN = 'ux/testrun-periods',
  MARKETING_DATA_SYNC_REPORT = 'marketing-data-sync-maintainance-log',
  TECHNICAL_UPSELLING_TERMS_AND_CONDITIONS = 'technical-upselling-installation-terms-and-conditions-web',
  SELLER_APPOINTMENT_ESCALATION_REASONS = 'escalation-reason',
  SELLER_APPOINTMENT_ESCALATION_REASONS_LIST = 'escalation-reason-list',
  SELLER_APPOINTMENT_ESCALATION_REASON_DETAIL = 'escalation-reason/detail',
  APPOINTMENT_ESCALATION_ROLE_LEVELS = 'ux/appointments/escalation-role-levels',
  ESCALATION_APPOINTMENTS = 'escalation/appointments',
  TICKETS_CANCELLATION_REQUEST_FORM = 'tickets/cancellation-request-form',
  ESCALATE_PENDING_UPDATE = 'escalation/pending-update',
  ESCALATE_NOSALE_UPDATE = 'escalation/nosale-update',
  MERCANTILE_LOGIN_DETAILS = 'mercantile-login-details',
  UX_SERVICE_ITEMS = 'ux/service-items',
  CUSTOMER_BANKING_UPDATE = 'customer-debtors/debit-date-update',
  SMS_CAMPAIGN = 'sms-campaigns',
  SMS_CAMPAIGN_CUSTOMERS = 'sms-campaigns-customers',
  UX_MAIN_AREA_BY_SUB_BRANCH = 'ux/main-areas-by-sub-branch',
  UX_DISCOUNT_TYPE = 'ux/discount-types',
  UX_TECHAREA_BOUNDARIES = 'ux/techarea-boundaries',
  UX_EVENT_CODES = 'ux/event-codes',
  SMS_CAMPAIGN_SCHEDULES = 'sms-campaigns-schedules',
  REFER_TO_SALES_ESCALATION = 'refer-to-sales-escalation',
  UX_LSS = 'ux/lss',
  UX_SERVICE_SIGNAL_MAPPINGS_ALARM_TYPES = 'ux/service-signal-mappings-alarm-types',
  SERVICE_SIGNAL_MAPPINGS = 'service-signal-mappings',
  BOC_DETAIL = 'lead-balance-of-contract-details',
  HOLIDAY_LIST = 'holidays-list',
  WORKING_DAYS = 'working-days',
  SUBSCRIPTION_CANCEL_CONTRACT_BILL_DATE_VALIDATE = 'subscription-cancel/contract-bill-date-validate',
  UX_ACTIVE_SUBSCRIPTIONS = 'ux/active-subscriptions',
  SCHEDULE_SERVICE_PRICE = 'schedule-service-price',
  SCHEDULE_SERVICE_PRICE_DETAILS = 'schedule-service-price/details',
  SCHEDULE_SERVICE_PRICE_CANCEL = 'schedule-service-price-cancel',
  CPA_NOTICES = 'cpa-notice',
  LSS_STOCK_CATEGORY = 'stock-categories',
  UX_SUBRUB_BY_SUB_AREA = 'ux/suburb-by-sub-areas',
  DIRECT_SALES_OPEN_LEAD = 'direct-sales/validate/open-counter-sale',
  COUNTER_SALES_DEBTOR_ACCEPTANCE = 'debtor-quotes-details-counter-sale',
  COUNTER_SALES_ACCEPT = 'debtor-online-acceptance-counter-sale',
  COUNTER_SALES_DECLINE = 'counter-sale-debtor-online-decline',
  CUSTOMER_CALLBACK_DETAILS = 'customer-callback/current/details',
  SUBSCRIPTION_SUSPEND_DATE_DETAIL = 'subscription-suspend-date/detail',
  STOP_AND_KNOCK_CREATE = 'leads/stop-and-knock',
  STOP_AND_KNOCK_ADDRESS_CHECK = 'relocation',
  RELOCATION_MAPPING_DETAILS = 'relocation-mapping-details',
  RELOCATION_TICKETS = 'relocation/tickets',
  POWER_BI_OPSCCC_TERMINATION_REPORTS = 'power-bi-termination-dashboard',
  POWER_BI_LIVE_SERVICE_LEVEL_REPORTS = 'power-bi-termination-dashboard-opscc',
  POWER_BI_LEAD_DASHBOARD_REPORTS = 'power-bi-lead-dashboard',
  POWER_BI_REACON_DASHBOARD_REPORTS = 'power-bi-recon-dashboard',
  POWER_BI_SAVE_OFFER_DASHBOARD = 'power-bi-save-offer-dashboard',
  DEBTOR_PAYMENT_METHOD = 'ux/payment-methods/dropdown',
  ADDS_POWER_BI_DASHBOARD = 'power-bi-Adds-dashboard',
  Run_IDT_POWER_BI_DASHBOARD = 'power-bi-Run-IDT-dashboard',
  DEFERRED_REVENUE_POWER_BI_DASHBOARD = 'power-bi-Deferred-Revenue-dashboard',
  DISCOUNTS_POWER_BI_DASHBOARD = 'power-bi-Discounts-dashboard',
  SUB_CONTRACTS_POWER_BI_DASHBOARD = 'power-bi-Sub-contracts-dashboard',
  TERMINATION_CANCELLATION_DASHBOARD='power-bi-termination-cancellation-dashboard',
  INCREASE_MONTH_DASHBOARD='power-bi-increase-month-dashboard',
  ALL_ACTIVE_DASHBOARD='power-bi-all-active-dashboard',
  AGE_ANALYSIS_DASHBOARD='power-bi-subscriber-age-analysis-dashboard',
  REINSTATES_DASHBOARD='power-bi-reinstates-dashboard',
  UNALLOCATED_OFFSETS_DASHBOARD='power-bi-unallocated-offsets-dashboard',
  STOCK_MOVEMENT_DASHBOARD='power-bi-stock-movement-dashboard',
  TECHNICAL_DASHBOARD='power-bi-technical-dashboard',
  SALES_DASHBOARD='power-bi-sales-dashboard',
  STOCK_VARIANCE_DASHBOARD='power-bi-stock-varience-dashboard',
  COUNTER_SALES_DASHBOARD='power-bi-counter-sales-dashboard',
  ORDER_NOT_YET_PICKED_DASHBOARD='power-bi-order-notyet-picked-dashboard',
  DISPATCH_ORDER_DASHBOARD='power-bi-dispatch-order-dashboard',
  STOCK_AGE_ANALYSIS_DASHBOARD='power-bi-stock-age-analysis-dashboard',
  STOCK_ON_HAND_DASHBOARD='power-bi-stock-on-hand-dashboard',
  OUTSTANDING_ORDER_DASHBOARD='power-bi-outstanding-order-dashboard',
  OVERDUE_PO_REPORT_DASHBOARD='power-bi-overdue-po-report-dashboard',
  CREDIT_NOTE_DASHBOARD= 'power-bi-credit-note-dashboard',
  SUBSCRIBER_MOVEMENT_DASHBOARD= 'power-bi-subscriber-movement-dashboard',
  RECURRING_REVENUE_DASHBOARD= 'power-bi-recurring-revenue-dashboard',
  GROUP_RADIO_DASHBOARD= 'power-bi-group-radio-dashboard',
  TRANSACTION_REPORT_DASHBOARD= 'power-bi-transaction-report-dashboard',
  GM_REPORT_DASHBOARD= 'power-bi-gm-report-dashboard',
  COST_OF_SALES_REPORT_DASHBOARD= 'power-bi-cost-of-sales-report-dashboard',
  OUTSTANDING_TRANSACTIONS_REPORT_DASHBOARD= 'power-bi-outstanding-transactions-report-dashboard',
  SERVICE_LEVEL_HISTORY_REPORT_DASHBOARD= 'power-bi-service-level-history-report-dashboard',
  CCC_LEADS_REPORT_DASHBOARD = 'power-bi-ccc-leads-report-dashboard',
  ALL_ACTIVES_PAGINATED_REPORT_DASHBOARD  = 'power-bi-all-actives-paginated-report-dashboard',
  CCC_TERMINATION_CANCELLATION_REPORT_DASHBOARD = 'power-bi-ccc-termination-cancellation-report-dashboard',
  ALL_ACTIVES_DETAIL_REPORT_DASHBOARD = 'power-bi-all-actives-detail-report-dashboard',
  REFUND_REPORT_DASHBOARD = 'power-bi-refund-report-dashboard'
  
}



enum btnActionTypes {
  NEXT = 'next',
  PREVIOUS = 'previous',
  SUBMIT = 'submit',
  SUBMIT_FAIL = 'submitFail',
  SERVICECATEGORY = 'service-Category',
  BACK_TO_LEAD = 'backToLead',
  CANCEL = 'cancel',
  EXIT_LEAD = 'exitLead'
}

enum NatureOfDebtor {
  ServiceDebtor = 1,
  TechnicalDebtor = 2
}

enum ConcessionStatus {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  NOT_APPLIED = 'Not Applied'
}

enum QuotationOutcomeStatus {
  ACCEPT = '1',
  NO_SALE = '2',
  PENDING = '3',
  DECLINE = '4'
}

enum LeadOutcomeStatusNames {
  ACCEPT = 'Aceept',
  NO_SALE = 'No-Sale',
  PENDING = 'Pending',
  DECLINE = 'Decline',
  SALE_COMPLETED = 'Sale Completed',
  QUOTATION_ACCEPTED = 'Quotation - Accept',
  QUOTATION_ISSUED = 'Quotation - Issued',
  QUOTATION_PENDING = 'Quotation - Pending',
  QUOTATION_DECLINED = 'Quotation - Decline',
  QUOTATION_EXPIRED = 'Quotation - Expired',
  SALE_ORDER_CREATED = 'Sale Order - Created'
}

enum ContractTypes {
  SERVICE_AGREEMENT = '1',
  INSTALLATION_AGREEMENTS = '2'
}

enum BoundaryStatus {
  INITIATED = 1,
  CREATED = 2,
  DRAFT_SAVED = 3,
  DOWNLOADED = 4,
  UPLOADED = 5,
  APPROVED = 6,
  REJECTED = 7,
  CANCELLED = 8,
  COMPLETED = 9,
  ROLL_BACK = 10,
  GO_LIVE = 11,
  LIVE = 12
}

enum BoundaryLayers {
  SUB_AREA = 1,
  MONITORING = 2,
  SERVICE = 3,
  INSTALLATION = 4,
  LSS = 5,
  RECONNECTION = 6,
  RESIDENTIAL = 7,
  SMALL_COMMERCIAL = 8
}

enum LssShiftCategories {
  WEEKDAYS = 1,
  WEEKENDS = 2,
  PUBLIC_HOLIDAYS = 3
}

enum AppointmentStatus {
  OPEN = 'Open',
  CLOSED = 'Closed',
  RESCHEDULED = 'Rescheduled',
  CANCELLED = 'Cancelled',
  BOOKED = 'Booked',
  INPROGRESS = 'InProgress'
}

enum LeadStatus {
  LEAD_CREATED = '1',
  STOP_AND_KNOCK = '2',
  APPOINTMENT_BOOKING = '3',
  QUOTATION_CREATED = '4',
  SALE_ORDER = '5',
  VETTING_FAILED = '6',
  TECHNICAL_PROVISIONAL_BOOKING = '7',
  NO_SALE = '8',
  SALE_COMPLETED = '9'
}

enum BoundaryApprovalStatus {
  OPEN = 1,
  INPROGRESS = 2,
  DECLINED = 3,
  APPROVED = 4
}

enum Sales_Leads_Components {
  LEADS = 'Leads',
  STOP_AND_KNOCK = 'Stop And knock',
  NEW_ADDRESS_APPROVAL = 'New Address Approval',
  REWARD_PARTNERSHIP = 'Reward Partnership',
  UNQUALIFIED_LEAD = 'Unqualified Lead',
  PARTITION_SEARCH = 'Partition Search',
  LEAD_LANDING_PAGE = "Landing Page",
  SALES_DOCS = 'Sales Documents',
  OTHER_DOCS = 'Other Documents',
  STAGE_ONE = 'Stage 1',
  STAGE_FOUR = 'Stage 4'
}

export {
  SalesModuleApiSuffixModels, btnActionTypes, NatureOfDebtor, ConcessionStatus, ContractTypes,
  QuotationOutcomeStatus, BoundaryStatus, BoundaryLayers, LssShiftCategories, AppointmentStatus,
  LeadOutcomeStatusNames, LeadStatus, BoundaryApprovalStatus, Sales_Leads_Components
};